import React, { useRef, useState, useEffect, useCallback } from 'react';

const ScrollHint = ({ children, className = '' }) => {
  const scrollRef = useRef(null);
  const [showHint, setShowHint] = useState(false);

  const checkScroll = useCallback(() => {
    const el = scrollRef.current;
    if (!el) return;
    // Show hint if content overflows and not scrolled to end
    const canScroll = el.scrollWidth > el.clientWidth + 1;
    const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;
    setShowHint(canScroll && !atEnd);
  }, []);

  useEffect(() => {
    checkScroll();
    window.addEventListener('resize', checkScroll);
    return () => window.removeEventListener('resize', checkScroll);
  }, [checkScroll]);

  // Re-check after children render/update
  useEffect(() => {
    const t = setTimeout(checkScroll, 100);
    return () => clearTimeout(t);
  });

  return (
    <div className="relative">
      <div
        ref={scrollRef}
        onScroll={checkScroll}
        className={`overflow-x-auto ${className}`}
      >
        {children}
      </div>
      {showHint && (
        <div className="sm:hidden absolute right-0 top-0 bottom-0 flex items-center pointer-events-none">
          <div className="h-full w-8 bg-gradient-to-l from-white/90 to-transparent" />
          <div className="absolute right-1 top-1/2 -translate-y-1/2 bg-gray-200/80 rounded-full p-1">
            <svg className="w-3 h-3 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 5l7 7-7 7" />
            </svg>
          </div>
        </div>
      )}
    </div>
  );
};

export default ScrollHint;
